<template>

  <el-container style="margin-top: 30px;margin-left: 50px;width: 100%;margin-bottom: 50px;">
    <div style="width: 60%;">
      <el-row :span="2">
      	<el-col :span="20" style="text-align: center;">
      	  <el-upload
      	      class="upload-demo"
      	      ref="upload1"
      	      :action="action()"
      	      :on-preview="handlePreview"
      	      :before-upload="beforeUpload"
      	      :data="uploadData"
      	      :on-error = "error"
      	      :on-success="successResave"
      	      :on-remove="handleRemove"
      	      :file-list="fileList"
      	      :auto-upload="false">
      	      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      	      <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>

      	  </el-upload>

      	</el-col>
      </el-row>
      <el-row :span="2" style="margin-top: 30px;margin-left: 50px;width: 100%;margin-bottom: 10px;overflow: y;">
        <el-button type="primary" style="background-color: #409eff;" @click="shai(0)" round>全部</el-button>
        <el-button type="primary" style="background-color: #409eff;" @click="shai(1)" round>未学习</el-button>
        <el-button type="primary" style="background-color: #409eff;" @click="shai(2)" round>已学习</el-button>
      </el-row>
      <el-row style="margin-top: 10px;margin-left: 50px;width: 100%;margin-bottom: 50px;overflow: y;">

        <template>
          <el-table
        	:data="list"
          height="1000"
        	border
        	style="width: 802px;margin-left: 0;height: 1150px;text-align: center;margin-top: 20px;">
          <el-table-column

            width="400"
            label="指令"
             >
             <template slot-scope="scope">
                 <div>{{scope.row.name}}</div>
             </template>
          </el-table-column>
          <el-table-column

            width="400"
            label="状态"
             >
             <template slot-scope="scope">
                 <div v-if="scope.row.t == 1">未学习</div>
                 <div v-if="scope.row.t == 2">已学习</div>
             </template>
          </el-table-column>
           </el-table>
        </template>
        <div class="page">
        	<el-pagination
        	  @size-change="loadList()"
        	  @current-change="loadList()"
        	  :current-page.sync="page"
        	  :page-size="20"
        	  background
        	  layout="total,prev, pager, next, jumper"
        	  :total="count">
        	</el-pagination>
        </div>
      </el-row>
     </div>

  </el-container>
</template>

<script>
  export default {
    data() {
       return {
         page:1,
         count:0,
        list:[],
        uploadData:{},
        file:'',
        fileList:[],
        dataAll:[],
        t:0

      }
    },
  directives: {
    },
    created() {
      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadList()
    },

  methods:{
    shai(t){
      this.t = t
      this.loadList()
    },
    action(){
      return "http://120.79.0.150/Learnupexcel"
    },
    submitUpload() {
      this.$refs.upload1.submit();
      let formData = new FormData();


    },
    handleRemove(file, fileList) {

    },
    handlePreview(file) {

       console.log(file);
     },
     beforeUpload (file) {

        this.uploadData = {lid:0,type:'ciku'};
        console.log(this.choses)

           let promise = new Promise((resolve) => {
               this.$nextTick(function () {
                   resolve(true);
               });
           });
           return promise;
    },
    //上传成功钩子
    successResave(response, file, fileList){
      this.loadList()

    },
    //失败钩子
     error(response, file, fileList){
           console.log(response)
     },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          t:this.t,
          p:this.page,

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/alearnList'
      })
      .then(res=>{

        this.list = res.data.list;

        this.count = res.data.count;


      })
      .catch(err=>{

      });
    },

    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/alearn.vue